// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { combineReducers } from 'redux';

import globalReducer from './globalStore/reducer';
import registerReducer from '../pages/register/store/reducers';
import loginReducer from '../pages/login/store/reducers';
import basketReducer from '../pages/basket/store/reducers';
import homeReducer from '../pages/home/store/reducers';
import contactReducer from '../pages/contact/store/reducers';
import confirmOrderReducer from '../pages/choose-delivery/store/reducers';
import forgotPasswordReducer from '../pages/forgot-password/store/reducers';
import ArrangeCollectionReducer from '../pages/arrange-collection/store/reducers';
import packGuidelinesReducer from '../pages/packaging-guidelines/store/reducers';
import howItWorksReducer from '../pages/howitworks/store/reducers';
import privacyPolicyReducer from '../pages/privacy-policy/store/reducers';
import faqsReducer from '../pages/faqs/store/reducers';
import termsAndConditionsReducer from '../pages/terms-and-conditions/store/reducers';
import qualityGuidelinesReducer from '../pages/guidelines/store/reducers';
import addressSearchReducer from
  '../pages/account/components/AccountTab/components/Address/store/reducers';
import parcelShopsReducer from '../pages/find-parcel-shop/store/reducers';
import ordersReducer from
  '../pages/account/components/AccountTab/components/MyOrders/store/reducers';
import profileReducer from
  '../pages/account/components/AccountTab/components/MyProfile/store/reducers';
import orderDetailsReducer from
  '../pages/account/components/AccountTab/components/OrderFull/store/reducers';
import fundraiseReducer from '../pages/fundraise/store/reducer';
import getPaidReducer from '../pages/get-paid/store/reducer';
import vouchersReducer from
  '../pages/account/components/AccountTab/components/Vouchers/store/reducers';
import issueVoucherReducer from
  '../pages/issue-voucher/store/reducers';
import customerOverviewReducer from
  '../pages/account/components/AccountTab/components/CustomerOverview/store/reducers';
import voucherConfirmedReducer from
  '../pages/voucher-confirmed/store/reducers';
import voucherDetailsReducer from
  '../pages/account/components/AccountTab/components/VoucherDetails/store/reducers';
import redeemVoucherReducer from '../pages/redeem-voucher/store/reducers';

export default combineReducers({
  globalReducer,
  loginReducer,
  registerReducer,
  ordersReducer,
  basketReducer,
  homeReducer,
  contactReducer,
  profileReducer,
  confirmOrderReducer,
  forgotPasswordReducer,
  ArrangeCollectionReducer,
  orderDetailsReducer,
  addressSearchReducer,
  parcelShopsReducer,
  packGuidelinesReducer,
  howItWorksReducer,
  faqsReducer,
  privacyPolicyReducer,
  termsAndConditionsReducer,
  qualityGuidelinesReducer,
  fundraiseReducer,
  getPaidReducer,
  vouchersReducer,
  issueVoucherReducer,
  customerOverviewReducer,
  voucherConfirmedReducer,
  voucherDetailsReducer,
  redeemVoucherReducer,
});
